import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-flexbox-grid";
import { Chip, Button } from "@material-ui/core";

const Pagination = ({ next, prev, page, nextDisabled = false }) => (
  <Row style={{ marginTop: "1rem" }}>
    <Col xs={4}>
      <Row start="xs">
        <Button
          variant="contained"
          color="primary"
          onClick={prev}
          disabled={page === 1}
        >
          &lt;
        </Button>
      </Row>
    </Col>
    <Col xs={4}>
      <Row center="xs">
        <Chip label={page} />
      </Row>
    </Col>
    <Col xs={4}>
      <Row end="xs">
        <Button
          variant="contained"
          color="primary"
          onClick={next}
          disabled={nextDisabled}
        >
          &gt;
        </Button>
      </Row>
    </Col>
  </Row>
);

Pagination.propTypes = {
  next: PropTypes.func.isRequired,
  prev: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  nextDisabled: PropTypes.bool
};

Pagination.defaultProps = {
  nextDisabled: false
};

export default Pagination;
